









































import Autocomplete from '@/components/Autocomplete.vue'
import Vue from 'vue'

export default Vue.extend({
  props: ['value'],
  components: {
    appAutocomplete: Autocomplete,
  },
})
